import React from "react";
import Meanings from "./Meanings";
import Phonetic from "./Phonetic";
import "./Results.css";


export default function Results(props) {
    
    if (props.results) {
    return ( 
    <div className="Results"> 
    <section> 
        <h2>{props.results.word}</h2>
        
        <Phonetic
            word={props.results.word}
             phonetic={props.results.phonetic}
        />
        </section>

    
         {props.results.meanings.map(function(meanings, index) {
            return (<section key={index}>
                <Meanings meaning={meanings} />
            </section>)
        })}
    
</div>
)
} else {
    return null;
}
}